import { cn } from "@/lib/utils";
import { createPortal } from "react-dom";

export const LoadingGate = ({
  loading,
  children,
}: {
  loading: boolean;
  children: React.ReactNode;
}) => {
  if (!loading) return children;

  return (
    <>
      <div style={{ display: "hidden" }}>{children}</div>
      {createPortal(
        <div
          className={cn(
            "bg-background fixed inset-0 top-0 left-0 z-1000 flex h-full w-full items-center justify-center",
          )}
        ></div>,
        document.body,
      )}
    </>
  );
};
